<template>
  <v-layout
      row
      align-center
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card
          class="ma-3 col-sm-6" outlined
      >
        <v-card-title>Set Time Slot Limit</v-card-title>
        <hr class="ma-1">
        <div class="col">
          <v-list>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
              <v-list-item
                  v-for="timeslot in timeslot_limits"
                  :key="timeslot.time"
              >
                <v-col cols="8 pa-0">
                  <v-text-field
                      :label="timeslot.time"
                      v-model="timeslot.limit"
                      outlined></v-text-field>
                </v-col>
              </v-list-item>
            </v-form>
          </v-list>
          <v-btn @click="save()" color="success" class="font-weight-bold">save</v-btn>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: true,
    daySelection: [
      {text: 'Sunday', value: 0},
      {text: 'Monday', value: 1},
      {text: 'Tuesday', value: 2},
      {text: 'Wednesday', value: 3},
      {text: 'Thursday', value: 4},
      {text: 'Friday', value: 5},
      {text: 'Saturday', value: 6}
    ],
    timeslot_limits: [],
    breadcrumbsItems: '',
  }),
  props: ['queue', 'operation_time'],
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
  },
  methods: {
    convertDayName(day) {
      let dayName = '';
      let d2 = day.split(",");
      this.daySelection.forEach(function (d) {
        d2.forEach(function (x) {
          if (d.value === parseInt(x)) dayName += d.text + ','
        })
      });
      return dayName;
    },
    weekDays() {
      return ['Sunday', 'Monday']
    },
    save() {
      let data = {timeslots: this.timeslot_limits}
      axios.post('/queue/' + this.queue.id + '/operation_time/' + this.operation_time.id, data)
          .then(response => {
                window.location.href = '/outlet/' + this.queue.outlet_id + '/queue/' + this.queue.id
              }
          );
    },
  },
  beforeMount() {
    this.timeslot_limits = JSON.parse(this.operation_time.timeslots);
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: false,
        href: '/outlet/' + this.queue.outlet_id + '/edit',
        link: true,
        text: 'Outlet',
      },
      {
        disabled: false,
        href: '/outlet/' + this.queue.outlet_id + '/queue/' + this.queue.id + '/edit',
        link: true,
        text: this.queue.name,
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Edit Timeslot',
      },
    ];
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Queues/TimeslotLimit.vue